// extracted by mini-css-extract-plugin
export default {"input":"MasterProcessInput_input__QM-KN"};